import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import ActiveHelper from '../../../components/common/activeHelper';
import { deviceWidth } from '../../../helpers/Utils';

const Banners = () => {
  const { activeItem } = useSelector(state => state.activeItem);
  const { banners, services, advServices, provider } = useSelector(state => state.providers);
  console.log(activeItem);

  const elements = useMemo(() => {
    const itemType = activeItem?.general?.type || activeItem?.type;

    const types = [
      { name: 'URL', key: 'url', id: 'url', isUrl: true },
      { name: 'Service', key: 'service', id: 'service', isUrl: false },
      { name: 'Service Provider', key: 'serviceProvider', id: 'serviceProvider', isUrl: false },
      { name: 'Navigation', key: 'navigation', id: 'navigation', isUrl: false }
    ];

    return [{
      key: 'generalInfo',
      title: 'General Information',
      data: [
        { key: 'img', title: 'Banner Image', width: '6', type: 'picture', dimensions: { width: 1280, height: 720, format: 'JPEG', quality: 80 } },
        { key: 'img_ar', title: 'Arabic Banner Image', width: '6', type: 'picture', dimensions: { width: 1280, height: 720, format: 'JPEG', quality: 80 } },
        {
          key: 'type',
          title: 'Banner Type',
          width: '12',
          data: types,
          type: 'select'
        },
        {
          key: 'url',
          title: itemType === 'navigation' ? 'Navigation' : 'URL',
          width: '12',
          type: 'text',
          hide: itemType !== 'url' && itemType !== 'navigation'
        },
        {
          key: 'service',
          title: 'Service',
          width: '12',
          data: Object.values(services || {}).concat(Object.values(advServices || {})).map(rec => ({ ...rec, name: rec.name, key: rec.key, id: rec.key })),
          type: 'select',
          hide: itemType !== 'service'
        },
        {
          key: 'serviceProvider',
          title: 'Service Provider',
          width: '12',
          data: Object.values(provider || {}).map(rec => ({ ...rec, name: rec.name, key: rec.key, id: rec.key })),
          type: 'select',
          hide: itemType !== 'serviceProvider'
        },
      ]
    },
    {
      key: 'scheduleInfo',
      title: 'Schedule Configuration',
      data: [
        {
          key: 'schedule',
          // title: 'Banner Schedule',
          
          width: '12',
          type: 'bannerSchedule'
        }
      ]
    }];
  }, [services, advServices, provider, activeItem?.type, activeItem?.general?.type]);

  const tableColumns = useMemo(() => {
    return [
      { Header: "Status", accessor: "active", width: 120, type: 'switch' },
      { Header: "", accessor: "img", width: deviceWidth() === 'desktop' ? 150 : 80, type: 'img' },
      { Header: "Type", accessor: "type", width: 150, type: 'label', show: deviceWidth() === 'desktop' },
      { Header: "Name", accessor: "name", width: 150, type: 'bannerName' },
      { Header: 'Created', accessor: 'created', type: 'date', show: deviceWidth() === 'desktop' },
    ];
  }, []);

  return (
    <div>
      <ActiveHelper
        data={Object.values(banners || {}) || []}
        title="Banners"
        selected='banners'
        elements={elements}
        tableColumns={tableColumns}
        permenatDelete={true}
        enableSorting={true}
        defaultSorting="active"
        showCreateButton={true}
      />
    </div>
  );
};


export default Banners;
